import { render, staticRenderFns } from "./MobileNavigation.vue?vue&type=template&id=b863a9aa&scoped=true&"
import script from "./MobileNavigation.vue?vue&type=script&lang=js&"
export * from "./MobileNavigation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b863a9aa",
  null
  
)

export default component.exports